import React from 'react';
import './HomeFirst.css'
import Title from '../../components/Title/Title';

const HomeFirst: React.FC = () => {
  return (
    <section className="home-first-container">
      <div className="home-first-content">
        <p className="home-first-preHeader">
          Steigern Sie Ihren Gewinn + Reduzieren Sie Ihre Entsorgungskosten 🡢	Lukratives Styropor Recycling von
        </p>
        <Title
          animated="Transportverpackung Isolierung Wärmedämmung"
        />
        <p className="home-first-subtitle">
          Auch verunreinigt, verdreckt, belastet oder mit HBCD Flammschutzmittel kontaminiert – StyroR entsorgt und recycelt alles in Hamburg!
        </p>
        <div className="home-first-grid">
          <div className="home-first-card">
            <h2>EPS & Styropor Recycling</h2>
            <ul>
              <li>Expandiertes Styropor recyceln</li>
              <li>Expandiertes Polystyrol entsorgen</li>
              <li>Airpop® fachgerecht verwerten</li>
              <li>Belastetes Styropor entsorgen (HBCD)</li>
            </ul>
          </div>
          <div className="home-first-card">
            <h2>Weitere Materialien recyceln</h2>
            <ul>
              <li>Extrudiertes Polystyrol entsorgen (XPS)</li>
              <li>Expandiertes Polypropylen recyceln (EPP)</li>
              <li>Expandiertes Polyethylen verwerten (EPE)</li>
              <li>Polyurethan fachgerecht entsorgen (PUR)</li>
            </ul>
          </div>
        </div>
        <p className="home-first-summary">
          Ob Transportverpackung aus dem Einzelhandel, Wärmedämmung von Baustellen oder Isolierung aus der Industrie – bei StyroR wird jedes Styropor fachgerecht recycelt. Viele Unternehmen wissen nicht, dass selbst stark verschmutztes oder HBCD-belastetes EPS wiederverwertet werden kann. Statt teurer Sondermüll-Entsorgung bieten wir eine wirtschaftliche und umweltfreundliche Lösung. Unser Recycling-Prozess sorgt dafür, dass wertvolle Rohstoffe erhalten bleiben und nicht in der Verbrennung verloren gehen. So wird aus Ihrem Abfall ein Beitrag zur Kreislaufwirtschaft.
        </p>
      </div>
    </section>
  );
};

export default HomeFirst;